<template>
  <transition :name="!scrollUp ? 'fourthBar' : 'fourthBar-reverse'">
    <div v-show="isActive" class="bg-page absolute-block">
      
      <div class="wrapper-bar-4">
        <div class="grid">
          <router-link
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: item.url }
              })
            "
            v-for="(item, index) in list"
            :key="item.id"
            class="grid__item"
          >
            <div class="card" :class="`card-${index + 1}`">
              <div class="card__category">{{ item.sub_category.name }}</div>
              <div class="card__img">
                <div class="rainbow"></div>
                <ImageContainer
                  class="img"
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                />
              </div>
              <div class="card__descr">
                <div class="card__title limited-text">{{ item.title }}</div>
                <div class="data-news">
                  <span class="day">{{ handleDate(item.pub_date) }},</span>
                  <span class="time">{{ handleTime(item.pub_date) }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    scrollUp: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style scoped lang="scss">
.bg-page {
  // padding-bottom: 5rem;
  background: url("../../assets/lifestyle-page/efe-kurnaz.jpg") no-repeat center;
  background-size: cover;
  width: 100%;
  // position: fixed;
  left: 0;
  top: 0;
}
.wrapper-bar-4 {
  --ofset-top: 9rem;
  padding-top: var(--ofset-top);
  padding-bottom: 1rem;
  max-width: 85%;
  margin: 0 auto;
  position: relative;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr) 400px repeat(2, 1fr);
  gap: 2rem 0;
  // height: 100vh;
  margin: 0 auto;
  &__item {
    grid-column: span 2;
  }
  &__item:nth-child(2) {
    grid-column: span 1;
    grid-row: span 2;
    place-self: center;
  }
  &__item:nth-child(5) {
    grid-column: 4 / span 2;
  }
  &__item:nth-child(1),
  &__item:nth-child(3),
  &__item:nth-child(5),
  &__item:nth-child(4) {
    perspective: 380px;
    perspective-origin: 50% 50%;
  }
  .card {
    &__descr {
      margin-top: 0.5rem;
    }
    &__img {
      position: relative;
      z-index: 1;
      transition: all 0.4s;
    }
    &__img {
      &:hover .rainbow {
        position: absolute;
        top: -4px;
        left: -4px;
        background: linear-gradient(
          90deg,
          rgba(255, 0, 0, 1) 9%,
          rgba(255, 188, 0, 1) 22%,
          rgba(255, 226, 0, 1) 37%,
          rgba(22, 255, 0, 1) 52%,
          rgba(0, 146, 255, 1) 66%,
          rgba(0, 31, 255, 1) 81%,
          rgba(186, 0, 236, 1) 100%
        );
        background-size: 400%, 400%;
        width: calc(100% + 8px);
        height: calc(100% + 8px);
        border-radius: 4px;
        z-index: -1;
        animation: animateCard 10s ease-out alternate infinite;
        &::after {
          content: "";
          position: absolute;
          top: -4px;
          left: -4px;
          background: linear-gradient(
            90deg,
            rgba(255, 0, 0, 1) 9%,
            rgba(255, 188, 0, 1) 22%,
            rgba(255, 226, 0, 1) 37%,
            rgba(22, 255, 0, 1) 52%,
            rgba(0, 146, 255, 1) 66%,
            rgba(0, 31, 255, 1) 81%,
            rgba(186, 0, 236, 1) 100%
          );
          background-size: 400%, 400%;
          width: calc(100% + 8px);
          height: calc(100% + 8px);
          border-radius: 4px;
          z-index: 0;
          animation: animateCard 10s ease-out alternate infinite;
          filter: blur(20px);
        }
      }
      &:hover {
        border-radius: 4px;
        &::before,
        &::after {
        }
        &::after {
          filter: blur(20px);
        }
      }
    }
    &__descr {
      position: relative;
      z-index: 3;
    }
    &__category {
      position: relative;
      z-index: 3;
      margin-bottom: 0.5rem;
    }
  }
  .card-1,
  .card-5,
  .card-3,
  .card-4 {
    max-width: 70%;
    .card__img {
      .img {
        padding-bottom: 60%;
      }
    }
  }
  .card-3,
  .card-5 {
    margin-left: auto;
  }
  .card-2 {
    // width: 90%;
    margin: 0 auto;
    .card__img {
      .img {
        padding-bottom: 75%;
      }
    }
  }
  .card-1,
  .card-4 {
    transform: scale3d(0.75, 0.85, 1) rotateX(0deg) rotateY(18deg) rotateZ(0deg)
      translate3d(0px, 0px, 0px) skew(0deg, 0deg);
  }
  .card-3,
  .card-5 {
    transform: scale3d(0.75, 0.85, 1) rotateX(0deg) rotateY(-18deg)
      rotateZ(0deg) translate3d(0px, 0px, 0px) skew(0deg, 0deg);
    .data-news {
      text-align: right;
    }
  }
}
@media screen and (max-width: 1500px) {
  .grid {
    height: 80vh;
    .card-1,
    .card-5,
    .card-3,
    .card-4 {
      max-width: 100%;
    }
  }
}
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .grid {
    height: 85vh;
    .card-1,
    .card-5,
    .card-3,
    .card-4 {
      max-width: max-content;
      width: 130%;
      // transform: translateX(-10%);
    }

    &__item {
      &:nth-child(4),
      &:nth-child(5) {
        align-self: end;
      }
    }
  }
  .card-1,
  .card-4 {
    transform: scale3d(0.75, 0.85, 1) rotateX(0deg) rotateY(18deg) rotateZ(0deg)
      translate3d(-70px, 0px, 0px) skew(0deg, 0deg) !important;
  }
  .card-3,
  .card-5 {
    transform: scale3d(0.75, 0.85, 1) rotateX(0deg) rotateY(-18deg)
      rotateZ(0deg) translate3d(0px, 0px, 0px) skew(0deg, 0deg);
  }
}

.fourthBar-enter-active,
.fourthBar-leave-active {
  transition: all 0.6s ease-out;
}
.fourthBar-enter-from {
  transform: translateY(100%);
}
.fourthBar-enter-to {
  transform: translateY(0);
}

.fourthBar-leave-from {
  transform: translateY(0);
}
.fourthBar-leave-to {
  transform: translateY(-100%);
}
.fourthBar-reverse-enter-active,
.fourthBar-reverse-leave-active{
  transition: all 0.6s;
}
.fourthBar-reverse-enter-from {
  transform: translateY(-100%);
}
.fourthBar-reverse-enter-to {
  // transform: translateY(100%);
}

.fourthBar-reverse-leave-from {
  transform: translateY(0);
}
.fourthBar-reverse-leave-to {
  transform: translateY(100%);
}

</style>
<style lang="scss">
@keyframes animateCard {
  0% {
    background-position: 0 50%;
  }
  25% {
    background-position: 50% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  75% {
    background-position: 50% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
